<template lang="pug">
div(v-if="!isMaranhao")
  el-row.caixa-pesquisa(:gutter="30")
    el-col.card-container(shadow="hover", style="margin: 15px 0 20px 0;")
        app-opcoes-header-analise.right(
          v-if="opcoesAcoes && processo",
          :idProcesso="idProcesso",
          :protocolo="numeroProtocolo"
          :statusProcesso="statusProcesso"
          :numeroProcesso="numeroProcesso",
          :tipoProcesso="tipoCodigoProcesso",
          :btnNotificarInteressado="false",
          :btnRetificacao="false",
          :btnSolicitarInformacao="false"
          )
    el-col(:span="8")
      h4 Núcleo ou Nome/razão social do interessado:
      el-input.span-style(
        type="text",
        :value="processo && processo.nomeRazaoSocialInteressado ? processo.nomeRazaoSocialInteressado : ''",
        :disabled="true")
    el-col(:span="8")
      h4 CPF/CNPJ do Interessado:
      el-input.span-style(
        type="text",
        :value="processo && processo.cpfCnpjInteressado ? processo.cpfCnpjInteressado  : ''",
        :disabled="true")
    el-col(:span="8")
      h4 Tipo de Processo:
      el-input.span-style(
        type="text",
        :value="processo && processo.tipo.codigo ? formatText(processo.tipo.codigo) : ''",
        :disabled="true")
    el-col(:span="8")
      h4 Setor:
      el-input.span-style(
        type="text",
        :value="processo && processo.setor ? formatText(processo.setor) : ''",
        :disabled="true")
    el-col(:span="8")
      h4 Status:
      el-input.span-style(
        type="text", :value="processo && processo.status ? formatText(processo.status) : ''",
        :disabled="true")
    el-col(:span="8", v-if="processo && processo.usuario && processo.usuario.pessoa")
      h4 Usuario:
      el-input.span-style(
        type="text", :value="processo && processo.usuario && processo.usuario.pessoa && processo.usuario.pessoa.nomeRazaoSocial ? processo.usuario.pessoa.nomeRazaoSocial : ''",
        :disabled="true")
div.container-geral(v-else)
  .opcoes-wrapper
    app-opcoes-header-analise(
      v-if="opcoesAcoes && processo",
      :idProcesso="idProcesso",
      :protocolo="numeroProtocolo"
      :statusProcesso="statusProcesso"
      :numeroProcesso="numeroProcesso",
      :tipoProcesso="tipoCodigoProcesso",
      :btnNotificarInteressado="false",
      :btnRetificacao="false",
      :btnSolicitarInformacao="false"
      )
  .center
    el-col(:span='8').flex
      app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
      app-display(label="CPF/CNPJ:", :content="processo.cpfCnpjInteressado")
    el-col(:span='8').flex
      app-display(label="Tipo de processo:", :content="processo.tipo.nome")
      app-display(label="Município:", :content="processo.municipios[0].nome")
    el-col(:span='8').flex
      app-display(label="Setor:", :content="formatText(processo.setor)")
      app-display(label="Status:", :content="formatText(processo.status)")

</template>

<script>
import AppOpcoesHeaderAnalise from '../../analise/components/modal/AppOpcoesHeaderAnalise.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  components: {
    AppOpcoesHeaderAnalise,
    AppDisplay
  },
  props: {
    processo: {
      type: Object,
      default: () => null
    },
    opcoesAcoes: {
      require: false,
      default: false
    },
    isMaranhao: {
      require: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatText (text) {
      return text ? text.replace(/_/g, ' ') : ''
    }
  },
  computed: {
    idProcesso () {
      return this.processo?.id || ''
    },
    numeroProcesso () {
      return this.processo?.numeroProcesso || ''
    },
    tipoCodigoProcesso () {
      return this.processo?.tipo.codigo || ''
    },
    statusProcesso () {
      return this.processo?.status || ''
    },
    numeroProtocolo () {
      return this.processo?.numeroProtocolo || ''
    }
  }
}
</script>

<style scoped>

.span-style {
  font-weight: normal;
  margin-left: 3px;
}
.right {
  display: flex;
  justify-content: right;
}
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.container-geral {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.opcoes-wrapper {
  align-self: flex-end;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/components/CardMoverProcessos.vue